import { RealEstateCategory, SegmentationType, TransactionType } from '../../../@types/types'
import { tracking, trackingOnPageLoad } from '../../../tracking/tracking'

// Map transaction type to tracking value
const mapTransactionTypeToTracking = (
  transaction: TransactionType | 'SHORT_TERM_ACCOMMODATION' | null | undefined
): string | undefined => {
  if (!transaction) return undefined

  switch (transaction) {
    case TransactionType.RENT:
      return 'rent'
    case TransactionType.SELL:
      return 'sale'
    case 'SHORT_TERM_ACCOMMODATION':
      return 'short_term_rent'
    default:
      return undefined
  }
}

// Map real estate category to tracking value
const mapRealEstateCategoryToTracking = (
  category: RealEstateCategory | 'BUSINESS' | null | undefined
): string | undefined => {
  if (!category) return undefined
  return category.toLowerCase().replace(/_/g, '_')
}

// Map segmentation to tracking value
const mapSegmentationToTracking = (segmentation: SegmentationType | null | undefined): string | undefined => {
  if (!segmentation) return undefined

  switch (segmentation) {
    case SegmentationType.PROPERTY_OWNER:
      return 'owner'
    case SegmentationType.TENANT:
      return 'tenant'
    case SegmentationType.AGENT:
      return 'agent'
    default:
      return undefined
  }
}

interface SegmentationTrackingParams {
  eventName: string
  selectedSegmentation?: SegmentationType | null
  transactionType?: TransactionType | 'SHORT_TERM_ACCOMMODATION' | null
  realEstateCategory?: RealEstateCategory | 'BUSINESS' | null
  errorReason?: string
}

// Track segmentation page events - dedicated function for segmentation page
export const trackSegmentationEvent = ({
  eventName,
  selectedSegmentation,
  transactionType,
  realEstateCategory,
  errorReason,
}: SegmentationTrackingParams) => {
  const role = mapSegmentationToTracking(selectedSegmentation)
  const purpose = mapTransactionTypeToTracking(transactionType)
  const category = mapRealEstateCategoryToTracking(realEstateCategory)

  tracking(
    {
      eventName,
      pageTitle: 'is24.de.anbieten',
      eventParameter1: role ?? null,
      eventParameter: purpose,
      moreEventParameters: {
        ...(category !== undefined ? { event_parameter_3: category } : {}),
        ...(errorReason !== undefined ? { event_parameter_4: errorReason } : {}),
      },
      ga_cd_test_ppa: undefined,
      ga_cd_test_is24_cxp_de_2: undefined,
    },
    true
  )
}

// Track segmentation page view - dedicated function for segmentation page
export const trackSegmentationPageView = () => {
  trackingOnPageLoad(
    undefined,
    undefined,
    undefined,
    'hpep_1647_treatment',
    undefined,
    'is24.de.anbieten.anzeige_schalten'
  )
}
